import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.738 2.762H8.085A3.82 3.82 0 0 0 4.25 6.49v10.713a3.83 3.83 0 0 0 3.742 3.91q.045.001.092 0h7.989a3.887 3.887 0 0 0 3.729-3.91V8.038z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.475 2.75v2.909a2.574 2.574 0 0 0 2.568 2.575h2.755M9.565 11.928v5.356M8 13l1.565-2 1.585 2"
    }, null, -1)
  ]))]))
}
export default { render: render }